import { Preferences } from "@capacitor/preferences";
import { isNativePlatform, STORAGE_KEYS } from "./storage";

/**
 * Get topic subscription status from storage
 */
export const getTopicSubscription = async (): Promise<boolean | null> => {
    try {
      if (isNativePlatform()) {
        const { value } = await Preferences.get({ key: STORAGE_KEYS.TOPIC_SUBSCRIPTION_ALL_USERS });
        if (value === 'true') return true;
        if (value === 'false') return false;
        return null;
      } else {
        const value = localStorage.getItem(STORAGE_KEYS.TOPIC_SUBSCRIPTION_ALL_USERS);
        if (value === 'true') return true;
        if (value === 'false') return false;
        return null;
      }
    } catch (error) {
      console.error('Error getting topic subscription:', error);
      return null;
    }
  };
  
  /**
   * Set topic subscription status in storage
   */
  export const setTopicSubscription = async (subscribed: boolean): Promise<void> => {
    try {
      const value = subscribed.toString();
      if (isNativePlatform()) {
        await Preferences.set({
          key: STORAGE_KEYS.TOPIC_SUBSCRIPTION_ALL_USERS,
          value,
        });
      } else {
        localStorage.setItem(STORAGE_KEYS.TOPIC_SUBSCRIPTION_ALL_USERS, value);
      }
    } catch (error) {
      console.error('Error setting topic subscription:', error);
    }
  };
  
  /**
   * Remove topic subscription from storage
   */
  export const removeTopicSubscription = async (): Promise<void> => {
    try {
      if (isNativePlatform()) {
        await Preferences.remove({ key: STORAGE_KEYS.TOPIC_SUBSCRIPTION_ALL_USERS });
      } else {
        localStorage.removeItem(STORAGE_KEYS.TOPIC_SUBSCRIPTION_ALL_USERS);
      }
    } catch (error) {
      console.error('Error removing topic subscription:', error);
    }
  };
  
  
  
  export const getTopicSubscriptionSync = (): boolean | null => {
    if (typeof window === 'undefined') return null;
    const value = localStorage.getItem(STORAGE_KEYS.TOPIC_SUBSCRIPTION_ALL_USERS);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  };